import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  'use strict';

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getProductData() {
    var el = document.getElementById('pawtee-product-json');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initGallery() {
    var gallery = document.querySelector('[data-pawtee-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('.pawtee-pdp__gallery-slide');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var dots = gallery.querySelectorAll('[data-dot]');
    var currentEl = gallery.querySelector('[data-gallery-current]');
    var total = slides.length;
    var index = 0;

    function playActiveVideo() {
      var activeVideo = gallery.querySelector('.pawtee-pdp__gallery-slide--video.is-active');
      slides.forEach(function (s) {
        if (s.tagName === 'VIDEO' && s !== activeVideo) {
          s.pause();
        }
      });
      if (activeVideo) {
        activeVideo.play().catch(function () {});
      }
    }

    function goTo(i) {
      if (!total) return;
      index = (i + total) % total;
      slides.forEach(function (s, si) {
        s.classList.toggle('is-active', si === index);
      });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-thumb'), 10) === index); });
      dots.forEach(function (d) { d.classList.toggle('is-active', parseInt(d.getAttribute('data-dot'), 10) === index); });
      if (currentEl) currentEl.textContent = String(index + 1);
      playActiveVideo();
    }

    goTo(0);

    slides.forEach(function (slide) {
      if (slide.tagName !== 'VIDEO') return;
      slide.addEventListener('loadeddata', playActiveVideo);
    });

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', function () { goTo(index - 1); });
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-dot'), 10)); });
    });

    var startX = 0;
    var viewport = gallery.querySelector('.pawtee-pdp__gallery-viewport');
    if (viewport) {
      viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 40) goTo(diff < 0 ? index + 1 : index - 1);
      }, { passive: true });
    }
  }

  function getOptionCount(product) {
    return (product && product.options && product.options.length) || 0;
  }

  function isVariantAvailable(variant) {
    return !!(variant && variant.available);
  }

  function getFirstAvailableVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    return product.variants.find(isVariantAvailable) || product.variants[0];
  }

  function findVariantByOptions(product, optionValues) {
    if (!product || !product.variants) return null;
    var count = getOptionCount(product);
    if (!count) return getFirstAvailableVariant(product);
    if (!optionValues || !optionValues.length) return null;

    count = Math.min(optionValues.length, count);

    return product.variants.find(function (v) {
      for (var i = 0; i < count; i++) {
        var variantValue = v['option' + (i + 1)];
        if (variantValue == null || variantValue !== optionValues[i]) return false;
      }
      return true;
    }) || null;
  }

  function getCartRoutes() {
    if (typeof Theme !== 'undefined' && Theme.routes) return Theme.routes;
    return {
      cart_add_url: '/cart/add.js',
      cart_url: '/cart',
    };
  }

  function getBundleConfig(bundleVal) {
    var n = parseInt(bundleVal, 10) || 1;
    if (n === 2) return { qty: 2, discount: 1000, lines: 2 };
    if (n === 3) return { qty: 3, discount: 2000, lines: 3 };
    return { qty: null, discount: 0, lines: 1 };
  }

  function getSortedSelects(lineEl) {
    if (!lineEl) return [];
    return Array.from(lineEl.querySelectorAll('select[data-pawtee-option]')).sort(function (a, b) {
      return parseInt(a.getAttribute('data-pawtee-option'), 10) - parseInt(b.getAttribute('data-pawtee-option'), 10);
    });
  }

  function initProductForm() {
    var product = getProductData();
    var pdp = document.querySelector('[data-pawtee-pdp]');
    if (!pdp || !product) return;

    var isDemo = product.demo === true;
    var mainForm = document.getElementById('pawtee-main-form');
    var qtyInput = pdp.querySelector('[data-pawtee-qty]');
    var qtyWrap = pdp.querySelector('[data-pawtee-qty-wrap]');
    var variantInput = pdp.querySelector('[data-pawtee-variant-id]');
    var subtotalVal = pdp.querySelector('[data-pawtee-subtotal-value]');
    var priceEl = pdp.querySelector('[data-pawtee-price]');
    var compareEl = pdp.querySelector('[data-pawtee-compare]');
    var saveEl = pdp.querySelector('[data-pawtee-save]');
    var atcBtn = pdp.querySelector('[data-pawtee-atc]');
    var stickyBtn = document.querySelector('[data-pawtee-sticky-atc]');
    var bundleInputs = pdp.querySelectorAll('[data-pawtee-bundle]');
    var bundleItems = pdp.querySelectorAll('[data-pawtee-bundle-item]');
    var optionCount = getOptionCount(product);
    var isAdding = false;

    function getBundleCard(bundleNum) {
      return pdp.querySelector('[data-pawtee-bundle-item="' + bundleNum + '"]');
    }

    function getSelectedBundle() {
      var checked = pdp.querySelector('[data-pawtee-bundle]:checked');
      return checked ? checked.value : '1';
    }

    function getLineElement(bundleCard, lineNum) {
      if (!bundleCard) return null;
      return bundleCard.querySelector('[data-pawtee-bundle-line="' + lineNum + '"]');
    }

    function getOptionValuesForLine(lineEl) {
      return getSortedSelects(lineEl).map(function (sel) { return sel.value; });
    }

    function resolveBundleItems(bundleNum) {
      var cfg = getBundleConfig(bundleNum);
      var card = getBundleCard(String(bundleNum));
      var items = [];

      for (var line = 1; line <= cfg.lines; line++) {
        var lineEl = getLineElement(card, line);
        var selects = getSortedSelects(lineEl);

        if (optionCount === 0) {
          var defaultVariant = getFirstAvailableVariant(product);
          if (!defaultVariant || !defaultVariant.id || !isVariantAvailable(defaultVariant)) {
            return { valid: false, items: [] };
          }
          items.push({
            line: line,
            variant: defaultVariant,
            optionValues: [],
            quantity: 1,
          });
          continue;
        }

        if (selects.length !== optionCount) {
          return { valid: false, items: [] };
        }

        var optionValues = getOptionValuesForLine(lineEl);
        var variant = findVariantByOptions(product, optionValues);

        if (!variant || !variant.id || !isVariantAvailable(variant)) {
          return { valid: false, items: [] };
        }

        items.push({
          line: line,
          variant: variant,
          optionValues: optionValues,
          quantity: 1,
        });
      }

      return { valid: true, items: items };
    }

    function getQty() {
      var cfg = getBundleConfig(getSelectedBundle());
      if (cfg.qty) return cfg.qty;
      return parseInt(qtyInput?.value, 10) || 1;
    }

    function sumVariantPrices(items, field) {
      return items.reduce(function (sum, item) {
        var v = item.variant;
        var val = field === 'compare' ? (v.compare_at_price || v.price) : v.price;
        return sum + (val || 0);
      }, 0);
    }

    function setLineToVariant(lineEl, variant) {
      if (!lineEl || !variant) return;
      getSortedSelects(lineEl).forEach(function (sel, index) {
        var value = variant['option' + (index + 1)];
        if (value != null) sel.value = value;
      });
    }

    function initializeLineSelections(lineEl) {
      if (!lineEl) return;
      var firstAvailable = getFirstAvailableVariant(product);
      if (firstAvailable) {
        setLineToVariant(lineEl, firstAvailable);
      }
      updateLineAvailability(lineEl);
    }

    function updateLineAvailability(lineEl) {
      if (!lineEl || !optionCount) return;
      var selects = getSortedSelects(lineEl);
      if (selects.length !== optionCount) return;

      var selected = getOptionValuesForLine(lineEl);

      selects.forEach(function (select, optionIndex) {
        Array.from(select.options).forEach(function (opt) {
          var testValues = selected.slice();
          testValues[optionIndex] = opt.value;
          var variant = findVariantByOptions(product, testValues);
          opt.disabled = !variant || !isVariantAvailable(variant);
        });

        var current = select.options[select.selectedIndex];
        if (!current || current.disabled) {
          var firstEnabled = Array.from(select.options).find(function (opt) { return !opt.disabled; });
          if (firstEnabled) select.value = firstEnabled.value;
        }
      });
    }

    function updateAllLineAvailability() {
      bundleItems.forEach(function (card) {
        card.querySelectorAll('[data-pawtee-bundle-line]').forEach(updateLineAvailability);
      });
    }

    function updateBundleCardPrices() {
      [1, 2, 3].forEach(function (n) {
        var resolved = resolveBundleItems(n);
        if (!resolved.valid) return;

        var cfg = getBundleConfig(String(n));
        var sum = sumVariantPrices(resolved.items, 'price');
        var compareSum = sumVariantPrices(resolved.items, 'compare');
        var total = Math.max(sum - cfg.discount, 0);
        var priceNode = pdp.querySelector('[data-bundle-price="' + n + '"]');
        var compareNode = pdp.querySelector('[data-bundle-compare="' + n + '"]');

        if (priceNode) priceNode.textContent = money(total);
        if (compareNode) {
          if (compareSum > total) {
            compareNode.textContent = money(compareSum);
            compareNode.style.display = '';
          } else {
            compareNode.style.display = 'none';
          }
        }
      });
    }

    function updateUI() {
      updateAllLineAvailability();

      var bundle = getSelectedBundle();
      var cfg = getBundleConfig(bundle);
      var resolved = resolveBundleItems(bundle);
      var primaryVariant = resolved.valid ? resolved.items[0].variant : null;
      var unit = primaryVariant ? primaryVariant.price : product.price;
      var compare = primaryVariant ? (primaryVariant.compare_at_price || primaryVariant.price) : product.compare_at_price;
      var qty = getQty();

      var total;
      if (cfg.lines > 1 && resolved.valid) {
        total = Math.max(sumVariantPrices(resolved.items, 'price') - cfg.discount, 0);
      } else if (resolved.valid) {
        total = Math.max(unit * qty - cfg.discount, 0);
      } else {
        total = Math.max(unit * qty, 0);
      }

      if (priceEl) priceEl.textContent = money(unit);
      if (compareEl && compare > unit) compareEl.textContent = money(compare);
      if (saveEl && compare > unit) {
        var pct = Math.round((compare - unit) * 100 / compare);
        saveEl.textContent = 'SAVE ' + pct + '%';
      }
      if (subtotalVal) subtotalVal.textContent = money(total);
      if (variantInput && primaryVariant && primaryVariant.id) variantInput.value = primaryVariant.id;

      if (qtyInput) {
        if (cfg.qty) {
          qtyInput.value = String(cfg.qty);
          qtyInput.readOnly = true;
          if (qtyWrap) qtyWrap.classList.add('is-locked');
        } else {
          qtyInput.readOnly = false;
          if (qtyWrap) qtyWrap.classList.remove('is-locked');
        }
      }

      updateBundleCardPrices();

      if (atcBtn) {
        atcBtn.disabled = !resolved.valid || isAdding;
        atcBtn.setAttribute('aria-disabled', resolved.valid && !isAdding ? 'false' : 'true');
      }

      if (stickyBtn) {
        stickyBtn.disabled = !resolved.valid || isAdding;
        stickyBtn.setAttribute('aria-disabled', resolved.valid && !isAdding ? 'false' : 'true');
      }

      var stickyPrice = pdp.querySelector('[data-pawtee-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(total);
    }

    function setActiveBundle(val) {
      bundleItems.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-pawtee-bundle-item') === val);
      });
      updateUI();
    }

    bundleInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        setActiveBundle(input.value);
      });
    });

    pdp.querySelectorAll('.pawtee-pdp__bundle select').forEach(function (sel) {
      sel.addEventListener('change', updateUI);
    });

    qtyInput?.addEventListener('change', updateUI);
    qtyInput?.addEventListener('input', updateUI);

    pdp.querySelector('[data-qty-minus]')?.addEventListener('click', function () {
      if (!qtyInput || qtyInput.readOnly) return;
      qtyInput.value = String(Math.max(1, getQty() - 1));
      updateUI();
    });
    pdp.querySelector('[data-qty-plus]')?.addEventListener('click', function () {
      if (!qtyInput || qtyInput.readOnly) return;
      qtyInput.value = String(getQty() + 1);
      updateUI();
    });

    function getCartSectionIds() {
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el instanceof HTMLElement && el.dataset.sectionId) {
          sectionIds.push(el.dataset.sectionId);
        }
      });
      return sectionIds;
    }

    function refreshCartJson() {
      return fetch(getCartRoutes().cart_url + '.json', {
        headers: { Accept: 'application/json' },
      }).then(function (r) { return r.json(); });
    }

    function addItemsToCart(cartItems) {
      var sectionIds = getCartSectionIds();
      var totalQuantity = cartItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      var deferred = CartLinesUpdateEvent.createPromise();

      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: cartItems.map(function (item) {
          return {
            merchandiseId: String(item.variant.id),
            quantity: item.quantity,
          };
        }),
        promise: deferred.promise,
      }));

      var payload = {
        items: cartItems.map(function (item) {
          return {
            id: Number(item.variant.id),
            quantity: item.quantity,
          };
        }),
      };

      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
      }

      return fetch(getCartRoutes().cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            throw new Error(response.message || response.description || 'Add to cart failed');
          }

          return refreshCartJson().then(function (ajaxCart) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: {
                items: ajaxCart.items,
                source: 'pawtee-pdp',
                itemCount: totalQuantity,
                productId: String(product.id || ''),
                sections: response.sections,
                didError: false,
              },
            });
            return response;
          });
        })
        .catch(function (error) {
          deferred.reject(error);
          throw error;
        });
    }

    function addToCart(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (isAdding) return;

      if (isDemo) {
        document.querySelector('[data-testid="cart-drawer-trigger"], .header-actions__action--cart, button[name="cart"]')?.click();
        return;
      }

      var bundle = getSelectedBundle();
      var cfg = getBundleConfig(bundle);
      var resolved = resolveBundleItems(bundle);

      if (!resolved.valid) return;

      var cartItems;
      if (cfg.lines > 1) {
        cartItems = resolved.items.map(function (item) {
          return { variant: item.variant, quantity: 1 };
        });
      } else {
        cartItems = [{ variant: resolved.items[0].variant, quantity: getQty() }];
      }

      isAdding = true;
      updateUI();

      addItemsToCart(cartItems)
        .catch(function (error) {
          console.error('[pawtee-pdp] Add to cart failed:', error);
        })
        .finally(function () {
          isAdding = false;
          updateUI();
        });
    }

    bundleItems.forEach(function (card) {
      card.querySelectorAll('[data-pawtee-bundle-line]').forEach(initializeLineSelections);
    });

    mainForm?.addEventListener('submit', addToCart);
    atcBtn?.addEventListener('click', addToCart);
    stickyBtn?.addEventListener('click', addToCart);

    initStickyAtcBar(atcBtn);

    updateUI();
  }

  function initMiniReviews() {
    var wrap = document.querySelector('[data-pawtee-mini-reviews]');
    if (!wrap) return;
    var track = wrap.querySelector('.pawtee-pdp-extras__reviews-track');
    var dots = wrap.querySelectorAll('.pawtee-pdp-extras__reviews-dots button');
    var cards = wrap.querySelectorAll('.pawtee-pdp-extras__review-card');
    if (!track || !cards.length) return;

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        cards[i]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');
      });
    });
  }

  function initStickyAtcBar(atc) {
    var sticky = document.querySelector('[data-pawtee-sticky]');
    if (!sticky || !atc) return;

    var closeBtn = sticky.querySelector('[data-pawtee-sticky-close]');
    var dismissed = false;

    var observer = new IntersectionObserver(function (entries) {
      if (dismissed) return;
      var visible = entries[0] && entries[0].isIntersecting;
      if (visible) sticky.setAttribute('hidden', '');
      else sticky.removeAttribute('hidden');
    }, { threshold: 0, rootMargin: '0px 0px -1px 0px' });

    observer.observe(atc);

    closeBtn?.addEventListener('click', function () {
      dismissed = true;
      sticky.setAttribute('hidden', '');
    });
  }

  function boot() {
    initGallery();
    initProductForm();
    initMiniReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
